import React from 'react';

const ChatInput = ({
  inputValue,
  onInputChange,
  onSendMessage,
  onKeyPress,
  disabled = false
}) => {
  return (
    <div className="px-lg-4 px-3 pb-3">
      <div className="position-relative mx-lg-4 mx-2 h-100">
        {/* <div className="position-absolute start-0 bottom-0 p-2">
          <button type="button" className="btn btn-lg px-1 py-1 text-body text-opacity-50">
            <i className="fa fa-fw fa-plus"></i>
          </button>
          <button type="button" className="btn btn-lg px-1 py-1 text-body text-opacity-50">
            <i className="fa fa-fw fa-globe"></i>
          </button>
          <button type="button" className="btn btn-lg px-1 py-1 text-body text-opacity-50">
            <i className="fa fa-fw fa-microphone"></i>
          </button>
        </div> */}
        <input 
          type="text" 
          className="form-control form-control-lg shadow-none rounded-2" 
          style={{ paddingBottom: '10px', paddingTop: '10px' }} 
          value={inputValue} 
          onChange={onInputChange} 
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onKeyPress(e);
            }
          }}
          id="userInput" 
          placeholder="Message AI Bot"
          disabled={disabled}
        />
        <div className="position-absolute end-0 bottom-0 px-2 pb-1">
          <button 
            id="sendButton" 
            onClick={onSendMessage} 
            className="btn btn-md bg-inverse text-inverse bg-opacity-20 rounded-2"
            disabled={disabled || !inputValue.trim()}
          >
            <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;